import React from "react";

import { Tooltip, Typography, Button } from "e100-react-components";

import { copyToClipboard } from "common/utils/index";

import { useIntl } from "react-intl";
import { useApplicationOperations } from "entities/application";
import { Icon } from "components";
import { useStyles } from "./styles";

export const CopyIconButton = ({ title, message }: CopyIconButtonProps) => {
  const { formatMessage } = useIntl();
  const { setErrorNotice, setSuccessNotice } = useApplicationOperations();
  const classes = useStyles();

  return (
    <div className={classes.tooltip}>
      <Tooltip
        title={title || formatMessage({ id: "replicate" })}
        enterDelay={1000}
        enterNextDelay={1000}
        enterTouchDelay={0}
      >
        <Button
          classes={{
            root: classes.root,
            label: classes.label,
          }}
          onClick={async (event) => {
            event.stopPropagation();
            event.preventDefault();

            try {
              await copyToClipboard(message);
              setSuccessNotice({ translateId: "copied" });
            } catch (e) {
              setErrorNotice({ translateId: "somethingGoWrong" });
            }
          }}
        >
          <Typography variant="body2">Location</Typography>
          <Icon kind="fileCopyOutlined" fontSize="small" />
        </Button>
      </Tooltip>
    </div>
  );
};

interface CopyIconButtonProps {
  title?: string;
  message: string;
}
